/**
 * Calcul de la hauteur de la grille en fonction du nombre d'element par page.
 */
function gridHeight(gridApi, withOffset = true) {
    var rowHeight = 30;
    return {
        height: gridApi.core.getVisibleRows(gridApi.grid).length * rowHeight + (withOffset ? 81 : 51) + 'px'
    };
}

export default gridHeight;
